(() => {
  const config = document.querySelector('[data-inventa-wishlist-config]');
  if (!config || window.inventaWishlistReady) return;
  window.inventaWishlistReady = true;
  let labels;
  try { labels = JSON.parse(config.dataset.labels || '{}'); } catch { labels = {}; }
  const label = (name, values = {}) => String(labels[name] || '').replace(/{{\s*(\w+)\s*}}|__INVENTA_(COUNT|TITLE)__/g, (_, key, marker) => String(values[key || marker.toLowerCase()] ?? ''));
  const root = window.Shopify?.routes?.root || '/';
  const key = 'inventa-wishlist-guest-v1';
  const endpoint = `${root}apps/inventa-quick-quote/wishlist`;
  const page = document.querySelector('[data-wishlist-page]');
  const loggedIn = config.dataset.customer === 'true';
  let items = [], token, revision = 0, ready = false, busy = false, initializing = false;
  let renderController, renderGeneration = 0;
  const status = page?.querySelector('[data-wishlist-status]') || Object.assign(document.createElement('p'), { className: 'sr-only inventa-type-compact' });
  if (!page) { status.setAttribute('role', 'status'); status.hidden = true; document.body.append(status); }
  const tell = message => { status.textContent = message; if (!page) { status.className = 'inventa-wishlist-feedback inventa-type-compact'; status.hidden = !message; } };
  const report = (operation, response) => console.warn('Inventa wishlist request failed', {operation, status: response?.status || 0});
  const valid = list => {
    if (!Array.isArray(list)) return [];
    const clean = list.filter(x => x && /^\d{1,20}$/.test(String(x.variantId)) && /^[a-z0-9][a-z0-9-]{0,254}$/.test(x.handle) && Number.isInteger(x.quantity) && x.quantity > 0 && x.quantity <= 9999).map(x => ({variantId: String(x.variantId), handle: x.handle, quantity: x.quantity}));
    return [...new Map(clean.map(x => [x.variantId, x])).values()].slice(0, 100);
  };
  const readGuest = () => { try { return valid(JSON.parse(localStorage.getItem(key) || '[]')); } catch { return []; } };
  const current = button => button.hasAttribute('data-product-detail') ? (button.closest('.shopify-section')?.querySelector('form[action*="/cart/add"] [name=id]')?.value || button.dataset.variant) : button.dataset.variant;
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-header]').forEach(link => {
      const count = items.length, badge = link.querySelector('[data-wishlist-count]');
      if (badge) { badge.textContent = ready && count ? String(count) : ''; badge.hidden = !ready || count === 0; }
      link.setAttribute('aria-label', ready && count ? label('header_count', {count}) : label('title'));
    });
    document.querySelectorAll('[data-wishlist-save]').forEach(button => {
      const present = items.some(x => x.variantId === String(current(button)));
      button.setAttribute('aria-pressed', String(present));
      button.setAttribute('aria-label', label(present ? 'remove_action' : 'save_action'));
      const text = button.querySelector('[data-wishlist-label]');
      if (text) text.textContent = label(present ? 'saved_label' : 'save_label');
    });
  }
  document.addEventListener('inventa:wishlist-buttons-added', syncButtons);
  async function persist(next) {
    if (next.length > 100) throw new Error(label('limit_error'));
    if (loggedIn) {
      const response = await fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: next, revision, token})});
      if (!response.ok) { report('save', response); throw new Error(label('save_error')); }
      const result = await response.json();
      revision = result.revision;
    } else {
      try { localStorage.setItem(key, JSON.stringify(next)); } catch { throw new Error(label('save_error')); }
    }
    items = next;
    syncButtons();
  }
  const selected = () => page ? [...page.querySelectorAll('[data-wishlist-select]:checked')].map(input => items.find(x => x.variantId === input.value)).filter(Boolean) : [];
  function selection() {
    if (!page) return;
    const count = selected().length;
    page.querySelector('[data-wishlist-selected-count]').textContent = label('selected_count', {count});
    page.querySelector('[data-wishlist-cart]').disabled = busy || !count;
    page.querySelector('[data-wishlist-quote]').disabled = busy || !count;
    page.querySelector('[data-wishlist-actions]').hidden = !ready || items.length === 0;
    page.querySelector('[data-wishlist-empty]').hidden = !ready || items.length > 0;
    const all = page.querySelector('[data-wishlist-all]');
    all.checked = count > 0 && count === items.length;
    all.indeterminate = count > 0 && count < items.length;
    all.disabled = busy || !ready || !items.length;
    page.querySelectorAll('[data-wishlist-select], [data-wishlist-remove]').forEach(control => { control.disabled = busy || !ready; });
    page.querySelectorAll('inventa-quantity[data-quantity-adapter="wishlist"]').forEach(quantity => {
      quantity.toggleAttribute('busy', busy);
      quantity.toggleAttribute('disabled', !ready);
    });
  }
  function createRow(item, checked) {
    const row = page.querySelector('[data-wishlist-row]').content.firstElementChild.cloneNode(true);
    row.dataset.id = item.variantId;
    const id = `wishlist-${page.dataset.wishlistContext}-${item.variantId}`;
    const choice = row.querySelector('[data-wishlist-select]');
    choice.id = `${id}-select`; choice.value = item.variantId; choice.checked = checked;
    choice.setAttribute('aria-label', label('select_product', {title: item.handle}));
    row.querySelector('[data-wishlist-select-label]').htmlFor = choice.id;
    row.querySelector('[data-wishlist-remove]').setAttribute('aria-label', label('remove_product', {title: item.handle}));
    const quantity = row.querySelector('inventa-quantity'), input = quantity.querySelector('input');
    input.id = `${id}-quantity`; input.value = input.defaultValue = String(item.quantity);
    quantity.querySelector('label').htmlFor = input.id;
    quantity.querySelector('.inventa-quantity__error').id = `${input.id}-error`;
    input.setAttribute('aria-describedby', `${input.id}-error`);
    return row;
  }
  async function render() {
    if (!page?.isConnected) return;
    renderController?.abort();
    const controller = renderController = new AbortController(), generation = ++renderGeneration;
    const selectedIds = new Set(selected().map(item => item.variantId));
    const target = page.querySelector('[data-wishlist-items]');
    page.querySelector('[data-wishlist-retry]').hidden = true;
    const snapshot = items.map(item => ({...item}));
    target.replaceChildren(...snapshot.map(item => createRow(item, selectedIds.has(item.variantId))));
    selection();
    const rows = [...target.children];
    for (let offset = 0; offset < rows.length && !controller.signal.aborted; offset += 4) {
      await Promise.all(rows.slice(offset, offset + 4).map(async row => {
        const item = snapshot.find(x => x.variantId === row.dataset.id);
        try {
          const response = await fetch(`${root}products/${item.handle}?variant=${item.variantId}&view=inventa-wishlist`, {cache: 'no-store', signal: controller.signal});
          if (!response.ok) throw new Error();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const product = doc.querySelector('[data-wishlist-product]');
          if (product?.dataset.variant !== item.variantId || !product.querySelector('[data-inventa-product-card]')) throw new Error();
          if (controller.signal.aborted || generation !== renderGeneration || !row.isConnected) return;
          row.querySelector('[data-item-content]').replaceWith(product);
          row.querySelector('[data-wishlist-select]').setAttribute('aria-label', label('select_product', {title: product.dataset.title}));
          row.querySelector('[data-wishlist-remove]').setAttribute('aria-label', label('remove_product', {title: product.dataset.title}));
          row.querySelectorAll('inventa-quantity [aria-label]').forEach(control => control.setAttribute('aria-label', `${control.getAttribute('aria-label')}: ${product.dataset.title}`));
          document.dispatchEvent(new Event('inventa:wishlist-buttons-added'));
        } catch {
          if (controller.signal.aborted || generation !== renderGeneration || !row.isConnected) return;
          row.querySelector('[data-item-content]').textContent = label('product_error');
          page.querySelector('[data-wishlist-retry]').hidden = false;
        }
      }));
    }
  }
  async function change(operation) {
    if (!ready) { tell(label('not_ready')); return; }
    if (busy) return;
    busy = true; selection();
    let after;
    try { after = await operation(); } catch (error) { tell(Object.values(labels).includes(error.message) ? error.message : label('action_error')); }
    finally { busy = false; selection(); if (typeof after === 'function') after(); }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-save]');
    if (!button) return;
    event.preventDefault();
    change(async () => {
      const variantId = String(current(button));
      const exists = items.some(x => x.variantId === variantId);
      const quantity = button.hasAttribute('data-product-detail') ? Number(button.closest('.shopify-section')?.querySelector('[name=quantity]')?.value || 1) : 1;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error(label('quantity_error'));
      await persist(exists ? items.filter(x => x.variantId !== variantId) : [...items, {variantId, handle: button.dataset.handle, quantity}]);
      tell(label(exists ? 'removed' : 'saved'));
      if (page) await render();
    });
  });
  document.addEventListener('change', () => setTimeout(syncButtons, 0));
  document.addEventListener('shopify:section:load', syncButtons);
  window.addEventListener('storage', event => {
    if (!loggedIn && (event.key === key || event.key === null) && !busy) { items = readGuest(); syncButtons(); render(); }
  });
  window.addEventListener('pagehide', () => { renderController?.abort(); renderGeneration++; });
  window.addEventListener('pageshow', event => { if (event.persisted && ready) { if (!loggedIn) items = readGuest(); syncButtons(); render(); } });
  if (page) {
    page.addEventListener('change', event => {
      if (event.target.matches('[data-wishlist-all]')) page.querySelectorAll('[data-wishlist-select]').forEach(input => { input.checked = event.target.checked; });
      selection();
    });
    page.addEventListener('inventa:quantity-change', event => {
      const quantity = event.target.closest('inventa-quantity[data-quantity-adapter="wishlist"]');
      if (!quantity) return;
      const input = quantity.querySelector('input'), row = quantity.closest('[data-id]');
      const previous = items.find(item => item.variantId === row.dataset.id)?.quantity;
      const restoreFocus = document.activeElement === input;
      change(async () => {
        const value = event.detail.value;
        if (!Number.isInteger(value) || value < 1 || value > 9999) { quantity.reset(previous); quantity.setError(label('quantity_error')); return; }
        try {
          await persist(items.map(item => item.variantId === row.dataset.id ? {...item, quantity: value} : item));
          quantity.reset(value); tell(label('quantity_saved'));
        } catch {
          quantity.reset(previous); quantity.setError(label('save_error')); tell(label('save_error'));
        }
        return () => { if (restoreFocus && input.isConnected && document.activeElement === document.body) input.focus({preventScroll: true}); };
      });
    });
    page.addEventListener('click', event => {
      if (event.target.closest('[data-wishlist-retry]')) { initialize(); return; }
      if (event.target.closest('[data-wishlist-remove]')) change(async () => {
        const row = event.target.closest('[data-id]');
        const next = row.nextElementSibling || row.previousElementSibling;
        await persist(items.filter(item => item.variantId !== row.dataset.id));
        row.remove(); tell(label('removed'));
        return () => (next?.querySelector('[data-wishlist-select]') || page.querySelector('[data-wishlist-empty] a')).focus({preventScroll: true});
      });
      if (event.target.closest('[data-wishlist-cart]')) change(async () => {
        const response = await fetch(`${root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: selected().map(item => ({id: item.variantId, quantity: item.quantity}))})});
        if (!response.ok) { report('cart', response); throw new Error(label('add_error')); }
        location.href = `${root}cart`;
      });
      if (event.target.closest('[data-wishlist-quote]')) change(async () => {
        const keyQuote = 'inventa-quote-selection-v1';
        let saved;
        try { saved = JSON.parse(localStorage.getItem(keyQuote) || 'null'); } catch { saved = null; }
        if (!saved || Date.now() - saved.savedAt >= 30 * 86400000 || !Array.isArray(saved.products)) saved = {products: [], customProducts: []};
        const picks = selected();
        if (new Set([...saved.products.map(item => String(item.variantId)), ...picks.map(item => item.variantId)]).size + (saved.customProducts?.length || 0) > 20) throw new Error(label('quote_limit_error'));
        for (const item of picks) {
          const response = await fetch(`${root}products/${item.handle}.js`, {cache: 'no-store'});
          if (!response.ok) throw new Error(label('quote_product_error'));
          const product = await response.json();
          if (!product.variants.some(variant => String(variant.id) === item.variantId)) throw new Error(label('quote_variant_error'));
          const existing = saved.products.find(product => String(product.variantId) === item.variantId);
          const entry = {product, variantId: item.variantId, quantity: String(item.quantity), targetPrice: existing?.targetPrice || ''};
          if (existing) Object.assign(existing, entry); else saved.products.push(entry);
        }
        saved.savedAt = Date.now(); localStorage.setItem(keyQuote, JSON.stringify(saved));
        window.dispatchEvent(new Event('inventa:quote-change')); location.href = `${root}pages/angebotsanfrage`;
      });
    });
  }
  async function initialize() {
    if (initializing) return;
    initializing = true; ready = false; selection(); tell(label('loading'));
    if (page) page.querySelector('[data-wishlist-retry]').hidden = true;
    try {
      const guest = readGuest();
      if (loggedIn) {
        const response = await fetch(endpoint, {cache: 'no-store'});
        if (!response.ok) { report('load', response); throw new Error(label('load_error')); }
        const result = await response.json(); items = valid(result.items); token = result.token; revision = result.revision;
        if (guest.length) {
          const merged = new Map(items.map(item => [item.variantId, item]));
          guest.forEach(item => { if (!merged.has(item.variantId)) merged.set(item.variantId, item); });
          await persist([...merged.values()]);
          try { localStorage.removeItem(key); } catch { /* Customer persistence succeeded; browser storage may be blocked. */ }
        }
      } else items = guest;
      ready = true; syncButtons(); tell(''); await render();
    } catch { tell(label('load_error')); if (page) page.querySelector('[data-wishlist-retry]').hidden = false; }
    finally { initializing = false; selection(); }
  }
  initialize();
})();
